var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAccountWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C20.9201 0 17.9663 1.2235 15.7884 3.40134C13.6106 5.57918 12.3871 8.53297 12.3871 11.6129C12.3871 14.6928 13.6106 17.6466 15.7884 19.8245C17.9663 22.0023 20.9201 23.2258 24 23.2258C27.0799 23.2258 30.0337 22.0023 32.2116 19.8245C34.3894 17.6466 35.6129 14.6928 35.6129 11.6129C35.6129 8.53297 34.3894 5.57918 32.2116 3.40134C30.0337 1.2235 27.0799 0 24 0ZM11.6129 29.4194C8.53297 29.4194 5.57918 30.6429 3.40134 32.8207C1.2235 34.9985 0 37.9523 0 41.0323V44.7112C0 47.0462 1.69084 49.0343 3.99484 49.409C17.2428 51.5737 30.7572 51.5737 44.0052 49.409C45.1194 49.2257 46.1325 48.6529 46.864 47.7927C47.5956 46.9324 47.9981 45.8405 48 44.7112V41.0323C48 37.9523 46.7765 34.9985 44.5987 32.8207C42.4208 30.6429 39.467 29.4194 36.3871 29.4194H35.3342C34.7561 29.4214 34.1946 29.5102 33.6495 29.6857L30.9677 30.5621C26.4402 32.0402 21.5598 32.0402 17.0323 30.5621L14.3505 29.6857C13.8069 29.5113 13.2397 29.4215 12.6689 29.4194H11.6129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAccountWhiteIcon);
export default __webpack_public_path__ + "static/media/mobile_account_white_icon.d92fbc14da3a37234809dc9a41f1c980.svg";
export { ForwardRef as ReactComponent };